import { createContainer, createStore, createHook, defaults } from 'react-sweet-state';

/**
 * @typedef {'Info' | 'Warning' | 'Success' | 'Error'} AlertType
 * @typedef {{ type: AlertType, text: string, createOnNavigate?: boolean }} Alert
 */

// Integrate react-sweet-state with the redux dev tools.
defaults.devtools = true;

export const INFO = 'Info';
export const ERROR = 'Error';
export const WARNING = 'Warning';
export const SUCCESS = 'Success';

/** @type {Alert} */
const emptyAlert = { type: null, text: null, createOnNavigate: false };

/**
 * @param {AlertType} type
 * @param {string} text
 * @param {boolean} [createOnNavigate=false]
 * @returns {Alert}
 */
export function createAlertConfig(type, text, createOnNavigate = false) {
    return { type, text, createOnNavigate };
}

function createAlert(alert) {
    return ({ setState }) => setState(alert);
}

const Store = createStore({
    name: 'Alerts',

    initialState: emptyAlert,

    actions: {
        createAlert,

        createInfoAlert:
            (text, createOnNavigate) =>
            ({ dispatch }) =>
                dispatch(createAlert(createAlertConfig(INFO, text, createOnNavigate))),

        createErrorAlert:
            (text, createOnNavigate) =>
            ({ dispatch }) =>
                dispatch(createAlert(createAlertConfig(ERROR, text, createOnNavigate))),

        createWarningAlert:
            (text, createOnNavigate) =>
            ({ dispatch }) =>
                dispatch(createAlert(createAlertConfig(WARNING, text, createOnNavigate))),

        createSuccessAlert:
            (text, createOnNavigate) =>
            ({ dispatch }) =>
                dispatch(createAlert(createAlertConfig(SUCCESS, text, createOnNavigate))),

        queueDelayedAlert:
            () =>
            ({ setState, getState }) => {
                if (getState() && getState().createOnNavigate) {
                    setState({ ...getState(), createOnNavigate: false });
                }
            },

        handleRemove:
            () =>
            ({ setState }) => {
                setState(emptyAlert);
            },
    },
});

export const AlertsContainer = createContainer(Store);

const useAlerts = createHook(Store);
export default useAlerts;
